import React, { useState } from 'react';
import {
    Form, Button, Spinner,
    Alert
} from 'react-bootstrap';

function WriteEntry(props) {

    let [entryText, setEntryText] = useState('');
    let [saved, setSaved] = useState(false);

    const onEntrySaved = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSaved(true);
        setEntryText('');
        props.onEntrySaved(entryText);
    };

    function getSubmitButton() {
        if (props.isLoading) {
            return (
                <Button disabled variant="primary">
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ marginRight: 5 }}
                    />
                    Sparar..
                </Button>
            );
        }
        else {
            return (
                <Button type="submit" variant="primary">
                    Spara
                </Button>
            );
        }
    }

    function getTextField() {
        if (props.isLoading) {
            return (
                <Form.Control disabled onChange={e => setEntryText(e.target.value)}
                    placeholder="Skriv anteckning.." as="textarea" rows="7" />
            );
        }
        else {
            return (
                <Form.Control value={entryText} onChange={e => setEntryText(e.target.value)}
                    placeholder="Skriv anteckning.." as="textarea" rows="7" />
            );
        }
    }

    function getAlert() {
        if (saved) {
            return <Alert variant="success">Anteckning sparad</Alert>
        }
    }

    if (!props.shown) {
            return <React.Fragment />;
    }
    else {
        return (
            <Form onSubmit={onEntrySaved}>
                {getAlert()}
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    {getTextField()}
                </Form.Group>
                {getSubmitButton()}
            </Form>
        );
    }
}

export default WriteEntry;